'use client'
import { useEffect } from 'react'
import { useIsMobile } from './use-media-query'

type OTPOptions = {
  transport: string[]
}

type CredentialRequestOptions = {
  otp: OTPOptions
  signal: AbortSignal
}

export const useOtpAutoFill = (onSetOtp: (otpCode: string) => void) => {
  const isMobile = useIsMobile()
  useEffect(() => {
    if (!isMobile) {
      return
    }

    if ('OTPCredential' in window) {
      const ac = new AbortController()
      const credentialRequestOptions: CredentialRequestOptions = {
        otp: { transport: ['sms'] },
        signal: ac.signal,
      }
      navigator.credentials
        .get(credentialRequestOptions)
        .then((otp) => {
          if (otp && 'code' in otp && typeof otp.code === 'string') {
            onSetOtp(otp.code)
          }
        })
        .catch(() => {
          return
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
